import React, { Component } from 'react';
// import { fonts, colors, metrics } from '../../../styles';

// //page title
import { Typography, TextField, MenuItem, Menu, Button, IconButton } from '@material-ui/core';

//Icons
import { KeyboardArrowLeft, KeyboardArrowRight, FilterList } from '@material-ui/icons';

//grid
import Grid from '@material-ui/core/Grid';



class FooterTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      list: [5, 10, 20, 25],
      rowsPerPage: this.props.rowsPerPage,
      anchorEl: false,
      pages: this.props.pages
    }

  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };


  render() {
    return (
      <Grid container style={{ padding: 10 }}>
        <Grid container item md={7} sm={12} xm={12} justify='flex-start' alignItems='center' direction='row'>
          <Grid item md={2} sm={2} xm={2} >
            <Typography style={{ height: '100%', fontSize: 12 }}>{this.props.labelRowsPerPage}:</Typography>
          </Grid>
          <Grid item md={2} sm={2} xm={2} style={{ paddingLeft: 5 }}>
            <TextField
              select
              style={{ width: '100%', textDecoration: 'none' }}
              value={this.state.rowsPerPage}
              onChange={event => {
                this.setState({ rowsPerPage: event.target.value })
                this.props.onChangeRowsPerPage(event.target.value);
              }}
              margin="normal"
            >
              {this.state.list.map(number => (
                <MenuItem key={number} value={number}>
                  {number}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item md={3} sm={3} xm={3} justify='center' alignItems='center' style={{ padding: 2 }}>
            <Typography style={{ fontSize: 12 }}>{this.props.page === 0 ? 1 : (this.props.rowsPerPage * this.props.page) + 1}-{this.props.pageLength === this.props.rowsPerPage ? this.props.pageLength * (this.props.page + 1) : this.props.count} of {this.props.count}</Typography>
          </Grid>
          <Grid item md={1} sm={1} xm={1} >
            <IconButton disabled={this.props.page < 1} onClick={() => this.props.onChangePage(this.props.page - 1)}><KeyboardArrowLeft /></IconButton>
          </Grid>
          <Grid item md={1} sm={1} xm={1}>
            <IconButton disabled={(this.props.page * this.props.rowsPerPage + this.props.pageLength) === this.props.count} onClick={() => this.props.onChangePage(this.props.page + 1)}><KeyboardArrowRight /></IconButton>
          </Grid>
        </Grid>
      </Grid>
    )
  }

}

export default FooterTable


// WEBPACK FOOTER //
// ./src/components/FooterTable.js